import type { KeyboardEvent } from "react"

// Keydown handler that runs `fn` when a non-button element with role="button" is
// activated by keyboard (Enter or Space), matching native button behaviour.
// preventDefault stops Space from scrolling the page.
export const onActivateKey =
  (fn: (e: KeyboardEvent<HTMLElement>) => void) => (e: KeyboardEvent<HTMLElement>) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault()
      fn(e)
    }
  }
